const toggleAddon = async (button, variantId) => {
  if (button.classList.contains('loading')) return;

  const isInCart = button.classList.contains('is-in-cart');
  button.classList.add('loading');

  const addUrl = `${window.Shopify.routes.root}cart/add.js`;
  const changeUrl = `${window.Shopify.routes.root}cart/change.js`;
  const requestUrl = isInCart ? changeUrl : addUrl;

  const payload = isInCart
    ? { id: variantId.toString(), quantity: 0 }
    : { items: [{ id: parseInt(variantId), quantity: 1 }] };

  try {
    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.description || 'Error updating cart');

    button.classList.toggle('is-in-cart');

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: false,
        detail: { source: 'product-addon' },
      })
    );

    updateSleekCartCount();
  } catch (error) {
    console.error('Sleek Cart Update Error:', error);
  } finally {
    button.classList.remove('loading');
  }
};

const updateSleekCartCount = async () => {
  try {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await res.json();

    document.querySelectorAll('.header__cart-count, .cart-count, #CartCount').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
      el.classList.remove('hidden', 'hide');
      if (cart.item_count > 0) el.style.display = '';
    });
  } catch (e) {
    console.error('Failed to update cart count manually', e);
  }
};

// ┌──────────────────────────────────────────────────┐
// │ Addon Button Sync                                │
// │ Reconciles button states against the live cart   │
// │ when an external cart change is detected         │
// └──────────────────────────────────────────────────┘

let syncInFlight = false;
let syncDebounceTimer = null;
const SYNC_DEBOUNCE_MS = 300;

const syncAddonButtonStates = () => {
  clearTimeout(syncDebounceTimer);

  syncDebounceTimer = setTimeout(async () => {
    if (syncInFlight) return;
    syncInFlight = true;

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await res.json();

      const cartVariantIds = new Set(cart.items.map(({ variant_id }) => variant_id));

      document.querySelectorAll('.addon-card[data-variant-id]').forEach((card) => {
        const variantId = parseInt(card.dataset.variantId);
        const button = card.querySelector('.addon-card__button');
        if (!button) return;

        button.classList.toggle('is-in-cart', cartVariantIds.has(variantId));
      });
    } catch (e) {
      console.error('Failed to sync addon button states', e);
    } finally {
      syncInFlight = false;
    }
  }, SYNC_DEBOUNCE_MS);
};

// ─── Primary: theme event listeners ───────────────────────────────────────────

let themeEventsActive = false;

['cart:updated', 'cart:change', 'cart:refresh'].forEach((eventName) => {
  document.addEventListener(eventName, (e) => {
    if (e.detail?.source === 'product-addon') return;
    themeEventsActive = true;
    syncAddonButtonStates();
  });
});

// ─── Fallback: MutationObserver ────────────────────────────────────────────────

const watchCartCountForChanges = () => {
  const cartCountEl = document.querySelector('.header__cart-count, .cart-count, #CartCount');
  if (!cartCountEl) return;

  let lastCount = cartCountEl.textContent.trim();

  const observer = new MutationObserver(() => {
    if (themeEventsActive) {
      observer.disconnect();
      return;
    }

    const newCount = cartCountEl.textContent.trim();
    if (newCount !== lastCount) {
      lastCount = newCount;
      syncAddonButtonStates();
    }
  });

  observer.observe(cartCountEl, {
    childList: true,
    subtree: true,
    characterData: true,
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchCartCountForChanges);
} else {
  watchCartCountForChanges();
}
